module.exports = __webpack_public_path__ + "img/black.6e35d6d8.jpg";